(function () {
  function setActiveImage(gallery, thumb) {
    var mainImage = gallery.querySelector('[data-product-gallery-main-image]') || gallery.querySelector('.hey-product-gallery__main img');
    if (!mainImage || !thumb) return;

    var src = thumb.getAttribute('data-gallery-src');
    var srcset = thumb.getAttribute('data-gallery-srcset');
    var alt = thumb.getAttribute('data-gallery-alt') || '';

    if (src) mainImage.setAttribute('src', src);
    if (srcset) mainImage.setAttribute('srcset', srcset);
    mainImage.setAttribute('alt', alt);

    gallery.querySelectorAll('[data-product-gallery-thumb]').forEach(function (button) {
      button.setAttribute('aria-current', button === thumb ? 'true' : 'false');
    });
  }

  function updateGalleryScrollButtons(shell) {
    var track = shell.querySelector('.hey-product-gallery__thumbs');
    var previous = shell.querySelector('[data-product-gallery-scroll="previous"]');
    var next = shell.querySelector('[data-product-gallery-scroll="next"]');
    if (!track || !previous || !next) return;

    var maxScroll = track.scrollWidth - track.clientWidth;
    previous.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= maxScroll - 2;
    shell.classList.toggle('is-scrollable', maxScroll > 2);
  }

  function initProductGalleries() {
    var galleries = document.querySelectorAll('[data-product-gallery]');
    if (!galleries.length) return;

    galleries.forEach(function (gallery) {
      var shell = gallery.querySelector('[data-product-gallery-thumbs]');
      var track = shell ? shell.querySelector('.hey-product-gallery__thumbs') : null;

      gallery.querySelectorAll('[data-product-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          setActiveImage(gallery, thumb);
        });
      });

      if (!shell || !track) return;

      shell.querySelectorAll('[data-product-gallery-scroll]').forEach(function (button) {
        button.addEventListener('click', function () {
          var direction = button.getAttribute('data-product-gallery-scroll') === 'next' ? 1 : -1;
          track.scrollBy({ left: direction * Math.max(120, track.clientWidth * .85), behavior: 'smooth' });
        });
      });

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(function () {
          updateGalleryScrollButtons(shell);
        });
      });

      window.addEventListener('resize', function () {
        updateGalleryScrollButtons(shell);
      });

      updateGalleryScrollButtons(shell);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductGalleries);
  } else {
    initProductGalleries();
  }
})();

(function () {
  var key = 'hey-store-collection-view';

  function readView() {
    try {
      return window.localStorage.getItem(key) || 'grid';
    } catch (error) {
      return 'grid';
    }
  }

  function writeView(view) {
    try {
      window.localStorage.setItem(key, view);
    } catch (error) {
      return;
    }
  }

  function setView(view, toggles, resultAreas) {
    var nextView = view === 'list' ? 'list' : 'grid';

    toggles.forEach(function (toggle) {
      var buttons = toggle.querySelectorAll('[data-view-option]');
      buttons.forEach(function (button) {
        button.setAttribute('aria-pressed', button.getAttribute('data-view-option') === nextView ? 'true' : 'false');
      });
    });

    resultAreas.forEach(function (area) {
      area.setAttribute('data-view', nextView);
    });

    writeView(nextView);
  }

  function initCollectionViewToggle() {
    var toggles = document.querySelectorAll('[data-view-toggle]');
    var resultAreas = document.querySelectorAll('[data-view-results]');
    if (!toggles.length || !resultAreas.length) return;

    setView(readView(), toggles, resultAreas);

    toggles.forEach(function (toggle) {
      var buttons = toggle.querySelectorAll('[data-view-option]');
      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          setView(button.getAttribute('data-view-option'), toggles, resultAreas);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionViewToggle);
  } else {
    initCollectionViewToggle();
  }
})();

(function () {
  var key = 'hey-store-wishlist';

  function readWishlist() {
    try {
      return JSON.parse(window.localStorage.getItem(key) || '[]');
    } catch (error) {
      return [];
    }
  }

  function writeWishlist(items) {
    try {
      window.localStorage.setItem(key, JSON.stringify(items));
    } catch (error) {
      return;
    }
  }

  function syncButton(button, items) {
    var handle = button.getAttribute('data-product-handle');
    var active = items.indexOf(handle) !== -1;
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.classList.toggle('is-saved', active);
  }

  function initWishlist() {
    var buttons = document.querySelectorAll('[data-wishlist-button]');
    if (!buttons.length) return;

    var items = readWishlist();
    buttons.forEach(function (button) {
      syncButton(button, items);
      button.addEventListener('click', function () {
        var handle = button.getAttribute('data-product-handle');
        if (!handle) return;

        items = readWishlist();
        var index = items.indexOf(handle);
        if (index === -1) {
          items.push(handle);
        } else {
          items.splice(index, 1);
        }

        writeWishlist(items);
        syncButton(button, items);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlist);
  } else {
    initWishlist();
  }
})();

(function () {
  function initProductForms() {
    var forms = document.querySelectorAll('.hey-product-form');
    if (!forms.length || typeof window.fetch !== 'function' || typeof window.FormData !== 'function') return;

    forms.forEach(function (form) {
      form.addEventListener('submit', function (event) {
        var submitter = event.submitter;
        if (submitter && submitter.name === 'checkout') return;

        event.preventDefault();

        var button = form.querySelector('button[type="submit"]');
        if (button) button.disabled = true;

        window.fetch('/cart/add.js', {
          method: 'POST',
          body: new window.FormData(form),
          headers: {
            Accept: 'application/json'
          }
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Add to cart failed');
            window.location.href = '/cart';
          })
          .catch(function () {
            if (button) button.disabled = false;
            form.submit();
          });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductForms);
  } else {
    initProductForms();
  }
})();

(function () {
  var levelToKind = {
    'Ort / Gemeinde': 'location',
    Landkreis: 'region',
    Region: 'region',
    Bezirk: 'region',
    Bayern: 'region',
    Global: 'country'
  };

  function clearResults(results) {
    results.innerHTML = '';
    results.hidden = true;
  }

  function setHiddenValues(picker, item) {
    var nodeInput = picker.querySelector('[data-geo-node-id]');
    var pathInput = picker.querySelector('[data-geo-path]');

    if (nodeInput) nodeInput.value = item && item.id ? item.id : '';
    if (pathInput) pathInput.value = item && item.path ? item.path : '';
  }

  function optionLabel(item) {
    return item.label || item.name || item.previewPath || item.path || '';
  }

  function optionPath(item) {
    return item.path || item.previewPath || item.preview_path || '';
  }

  function renderResults(picker, results, items) {
    clearResults(results);

    if (!items.length) {
      var empty = document.createElement('div');
      empty.className = 'hey-geo-empty';
      empty.textContent = 'Keine Treffer';
      results.appendChild(empty);
      results.hidden = false;
      return;
    }

    items.forEach(function (rawItem) {
      var item = {
        id: rawItem.id || rawItem.geoNodeId || rawItem.geo_node_id || '',
        label: optionLabel(rawItem),
        kind: rawItem.kind || rawItem.nodeKind || rawItem.node_kind || rawItem.level || '',
        path: optionPath(rawItem)
      };

      if (!item.label) return;

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'hey-geo-option';

      var title = document.createElement('strong');
      title.textContent = item.label;
      button.appendChild(title);

      if (item.path || item.kind) {
        var meta = document.createElement('small');
        meta.textContent = [item.kind, item.path].filter(Boolean).join(' · ');
        button.appendChild(meta);
      }

      button.addEventListener('click', function () {
        var search = picker.querySelector('[data-geo-search]');
        if (search) search.value = item.label;
        setHiddenValues(picker, item);
        clearResults(results);
      });

      results.appendChild(button);
    });

    results.hidden = results.children.length === 0;
  }

  function initGeoPicker() {
    var pickers = document.querySelectorAll('[data-geo-picker]');
    if (!pickers.length || typeof window.fetch !== 'function') return;

    pickers.forEach(function (picker) {
      var endpoint = picker.getAttribute('data-geo-endpoint');
      var search = picker.querySelector('[data-geo-search]');
      var results = picker.querySelector('[data-geo-results]');
      var assignment = picker.closest('[data-hey-assignment]');
      var levelSelect = assignment ? assignment.querySelector('[name="properties[Geo-Ebene]"]') : null;
      var portalSelect = assignment ? assignment.querySelector('[name="properties[Portal]"]') : null;
      var timer;
      var controller;

      if (!endpoint || !search || !results) return;

      search.addEventListener('input', function () {
        var query = search.value.trim();
        setHiddenValues(picker, null);
        window.clearTimeout(timer);

        if (query.length < 2) {
          clearResults(results);
          return;
        }

        timer = window.setTimeout(function () {
          if (controller && typeof controller.abort === 'function') controller.abort();
          if (typeof window.AbortController === 'function') controller = new window.AbortController();

          var level = levelSelect ? levelSelect.value : '';
          var portal = portalSelect ? portalSelect.value : '';
          var country = picker.getAttribute('data-geo-country') || '';
          var params = new URLSearchParams({
            q: query,
            limit: '8'
          });

          if (level) params.set('level', level);
          if (levelToKind[level]) params.set('kind', levelToKind[level]);
          if (portal) params.set('portal', portal);
          if (country && level !== 'Global') params.set('country', country);

          window.fetch(endpoint + '?' + params.toString(), {
            headers: { Accept: 'application/json' },
            signal: controller ? controller.signal : undefined
          })
            .then(function (response) {
              if (!response.ok) throw new Error('Geo search failed');
              return response.json();
            })
            .then(function (payload) {
              var items = Array.isArray(payload) ? payload : payload.items || payload.nodes || [];
              renderResults(picker, results, items);
            })
            .catch(function (error) {
              if (error && error.name === 'AbortError') return;
              clearResults(results);
            });
        }, 220);
      });

      search.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') clearResults(results);
      });

      if (levelSelect) {
        levelSelect.addEventListener('change', function () {
          setHiddenValues(picker, null);
          clearResults(results);
        });
      }

      document.addEventListener('click', function (event) {
        if (!picker.contains(event.target)) clearResults(results);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGeoPicker);
  } else {
    initGeoPicker();
  }
})();
